export default "__VITE_ASSET__$Ro73ZMG__"